import { connect } from 'react-redux';

import SmsEditScreen from '../components/SmsEditScreen';

const mapStateToProps = (state) => {
  return {
    isLoading: state.emails.get('isLoading'),
    success: state.emails.getIn(['form', 'success']),
  };
};

const SmsEditScreenContainer = connect(mapStateToProps)(SmsEditScreen);

export default SmsEditScreenContainer;
